// import React, { useState } from "react";
// import Signup from "./Signup";
// import OTPNew from "./OTPNew";

// const SignupFlow = () => {
//   const [page, setPage] = useState(0); // 0 = signup, 1 = OTP
//   const [token, setToken] = useState(null); // ⬅️ Save token from signup API

//   return (
//     <>
//       {page === 0 && (
//         <Signup
//           setPage={setPage}
//           setToken={setToken} // ⬅️ Pass function to store token
//         />
//       )}

//       {page === 1 && (
//         <OTPNew
//           setPage={setPage}
//           token={token}
//           // ⬅️ Pass token to OTP page
//           onClose={() => setPage(0)} // optional
//         />
//       )}
//     </>
//   );
// };

// export default SignupFlow;
import React, { useState } from "react";
import Signup from "./Signup";
import OTPNew from "./OTPNew";
import { Navigate } from "react-router-dom"; //  import this

const SignupFlow = ({ setIsUnRegistered }) => {
  const [page, setPage] = useState(0); // 0 = signup, 1 = OTP, 2 = done
  const [token, setToken] = useState(null);
  // const [mobile, setMobile] = useState(""); //  To show on OTP screen
  // const [countryCode, setCountryCode] = useState("");

  return (
    <>
      {page === 0 && (
        <Signup
          setPage={setPage}
          setToken={setToken}
          setIsUnRegistered={setIsUnRegistered}
          onClose={() => {
            document.body.style.overflow = "auto";

            setPage(2);
          }}
        />
      )}
      {page === 1 && (
        <OTPNew
          setPage={setPage}
          token={token}
          onClose={() => {
            document.body.style.overflow = "auto";

            setPage(0);
          }} // mobile={mobile}
          // countryCode={countryCode}
        />
      )}
      {page === 2 && <Navigate to="/" replace />}{" "}
      {/* 👈 this will redirect to homepage */}
    </>
  );
};

export default SignupFlow;
